import { Injectable } from '@angular/core';

import { Http, Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { UrlSegment } from '@angular/router'

export class SiteMapItems {
    ItemLevel: number;
    ItemURL: string;
    ItemName: string;
    ItemParentName: string;
    showDetails: boolean;
    lvl3Items: any;
}

export interface GaWebMenuItem {
    ItemLabel: string;
    ItemURL: string;
    ItemName: string;
}


export class BannerCrop {
    alias: string;
    height: number;
    width: number;
}

export class Banner {
    src: string;
    focalPoint: string;
    crops: Array<BannerCrop>;
}

export class UserData {
    Email: string;
    FirstName: string;
    Surname: string;
    Salutation: string;
    PhoneNumber: string;
    CustomerGuid: string;
    Country: string;
    Gender: string;
    TCAcceptDate: Date;
}

export class Country {
    Code: string;
    CountryName: string;
}

export class State {
    Code: string;
    Name: string;
}

export class Title {
    Text: string;
    Value: string;
}

export class ExpressInitialData {
    AvailabilityUrl: string;
    PassengersUrl: string;
    PaymentUrl: string;
    ParentFolderUrl: string;
    SeatConfirmationUrl: string;
    ConfirmationUrl: string;
}
export class TravelPassesInitialData extends ExpressInitialData {
    CategoriesUrl: string;
    ProductsUrl: string;
    DetailsUrl: string;
}
export class ManageBookingInitialData {
    DetailsUrl: string;
    ManageAvailabilityUrl: string;
    PaymentUrl: string;
}

export class PassengerFareType {
    Code: string;
    Display: string;
    Description: string;
    ConcessionCardRequired: boolean;
    IsChild: boolean;
    IsInfant: boolean;
    NonChildRequired: boolean;
    ReturnCode: string;
}

export class MyGreyhoundInitialData {
    ProfileUrl: string;
    DashboardUrl: string;
}

export class SpecialAssistanceType {
    Description: string;
    Index: string;
    MaxPax: string;
    MinPax: string;
}
class Product {
    PassengersUrl: string;
    CategoriesUrl: string;
    ProductsUrl: string;
    DetailsUrl: string;
    ParentFolderUrl: string;
    NAME: string;
}
export class Packages extends Product {
    NAME = 'package';
}
export class Experiences extends Product {
    NAME = 'experience';
}
export class Accommodation extends Product {
    NAME = 'accommodation';
}
export class InitialDataModel {
    AppVersion: string;
    RegistrationNewsletterConfirmation: string;
    Version: string;
    WebSiteUrl: string;
    Express: ExpressInitialData;
    ConfirmationUrl: string;
    ManageBooking: ManageBookingInitialData;
    TimetablesUrl: string;
    HomeUrl: string;
    HomeUrlExpress: string;
    HomeUrlManage: string;
    Countries: Array<Country>;
    FareTypes: Array<PassengerFareType>;
    SpecialAssistanceTypes: Array<SpecialAssistanceType>;
    SiteMap: Array<SiteMapItems>;
    UserData: UserData;
    LoginUrl: string;
    LogoutUrl: string;
    RegisterUrl: string;
    MyGreyhound: MyGreyhoundInitialData;
    States: Array<State>;
    Titles: Array<Title>;
    Packages: Packages;
    Experiences: Experiences;
    Accommodation: Accommodation;
    TravelPassesInitialData: TravelPassesInitialData;
    RecaptchaV3SiteKey: string;
    RecaptchaV3SecretKey: string;
}


@Injectable()
export class InitialDataService {

    private getSitemapUrl = '/umbraco/api/InitialData/GetSitemap';

    public initialData: InitialDataModel;

    public categoryReference = '';
    public showAsDropdown = false;

    get passengersUrl(): string {
        return this.initialData.Express.PassengersUrl;
    }
    get webSiteUrl(): string {
        return this.initialData.WebSiteUrl;
    }
    get version(): string {
        return this.initialData.Version;
    }
    get userData(): UserData {
        return this.initialData.UserData;
    }
    get countries(): Array<Country> {
        return this.initialData.Countries;
    }
    get states(): Array<State> {
        return this.initialData.States;
    }
    get titles(): Array<Title> {
        return this.initialData.Titles;
    }
    get fareTypes(): Array<PassengerFareType> {
        return this.initialData.FareTypes;
    }
    get loginUrl(): string {
        return this.initialData.LoginUrl;
    }
    get express(): ExpressInitialData {
        return this.initialData.Express;
    }
    get expressPayment(): string {
        return this.initialData.Express.PaymentUrl;
    }
    get expressSeatConfirmation(): string {
        return this.initialData.Express.SeatConfirmationUrl;
    }
    get expressConfirmation(): string {
        return this.initialData.Express.ConfirmationUrl;
    }
    get expressPassengers(): string {
        return this.initialData.Express.PassengersUrl;
    }
    get expressAvailability(): string {
        return this.initialData.Express.AvailabilityUrl;
    }
    get expressParentFolderUrl(): string {
        return this.initialData.Express.ParentFolderUrl;
    }
    get manageBooking(): ManageBookingInitialData {
        return this.initialData.ManageBooking;
    }
    get confirmationUrl(): string {
        return this.initialData.ConfirmationUrl;
    }
    get isLoggedIn(): boolean {
        return !!this.userData;
    }
    get packagePassengers(): string {
        return this.initialData.Packages.PassengersUrl;
    }
    get packageCategories(): string {
        return this.initialData.Packages.CategoriesUrl;
    }
    get packageProducts(): string {
        return this.initialData.Packages.ProductsUrl;
    }
    get packageDetails(): string {
        return this.initialData.Packages.DetailsUrl;
    }
    get packageParentFolderUrl(): string {
        return this.initialData.Packages.ParentFolderUrl;
    }
    get experiencePassengers(): string {
        return this.initialData.Experiences.PassengersUrl;
    }
    get experienceCategories(): string {
        return this.initialData.Experiences.CategoriesUrl;
    }
    get experienceProducts(): string {
        return this.initialData.Experiences.ProductsUrl;
    }
    get experienceDetails(): string {
        return this.initialData.Experiences.DetailsUrl;
    }
    get experienceParentFolderUrl(): string {
        return this.initialData.Experiences.ParentFolderUrl;
    }
    get accommodationPassengers(): string {
        return this.initialData.Accommodation.PassengersUrl;
    }
    get accommodationCategories(): string {
        return this.initialData.Accommodation.CategoriesUrl;
    }
    get accommodationProducts(): string {
        return this.initialData.Accommodation.ProductsUrl;
    }
    get accommodationDetails(): string {
        return this.initialData.Accommodation.DetailsUrl;
    }
    get accommodationParentFolderUrl(): string {
        return this.initialData.Accommodation.ParentFolderUrl;
    }
    get travelPassesPassengers(): string {
        return this.initialData.TravelPassesInitialData.PassengersUrl;
    }
    get travelPassesCategories(): string {
        return this.initialData.TravelPassesInitialData.CategoriesUrl;
    }
    get travelPassesProducts(): string {
        return this.initialData.TravelPassesInitialData.ProductsUrl;
    }
    get travelPassesDetails(): string {
        return this.initialData.TravelPassesInitialData.DetailsUrl;
    }
    get travelPassesPayment(): string {
        return this.initialData.TravelPassesInitialData.PaymentUrl;
    }
    get travelPassesParentFolderUrl(): string {
        return this.initialData.TravelPassesInitialData.ParentFolderUrl;
    }
    get makeABookingUrl(): string {
        return '/book-a-ticket';
    }
    get registrationNewsletterConfirmation(): string {
        return this.initialData.RegistrationNewsletterConfirmation;
    }
    get recaptchV3SiteKey(): string {
        return this.initialData.RecaptchaV3SiteKey;
    }
    get recaptchaV3SecretKey(): string {
        return this.initialData.RecaptchaV3SecretKey;
    }
    constructor(private http: Http) { }

    getSitemap(): Observable<SiteMapItems[]> {
        return this.http.get(this.getSitemapUrl)
            .map(this.extractCategories)
            .catch(this.handleError);
    }

    private extractCategories(res: Response) {
        return res.json();
    }

    private handleError(error: Response | any) {
        // In a real world app, you might use a remote logging infrastructure
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable.throw(errMsg);
    }

    public getCategoryRef(snapshotUrl: UrlSegment[]) {
        const isMvcLoad = !!this.categoryReference;
        const lastSegment = snapshotUrl[snapshotUrl.length - 1];
        let categoryRef;
        if (isMvcLoad) {
            categoryRef = this.categoryReference;
        } else {
            categoryRef = !!lastSegment ? lastSegment.path : '';
        }
        return categoryRef;
    }
}



// WEBPACK FOOTER //
// ./src/app/initial-data.service.ts